import { render } from "./ShortcutModal.vue?vue&type=template&id=06c7cdc0"
import script from "./ShortcutModal.vue?vue&type=script&lang=js"
export * from "./ShortcutModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__